export default __webpack_public_path__ + "static/N0105-fb5ae5239023f1bae114da116c050883.png";